// This function uses the function declaration syntax because of the asserts clause in the return type
export function assertIsDefined<T>(value: T, message?: string): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new Error(message ?? `${value} is not defined`);
  }
}
